import React from 'react';
import Badge from '@material-ui/core/Badge';
import SimpleTabs from './TabIndi';
import TablaParos from './TablaParos';
import { useGeneral } from '../../Context/GeneralContext';
import GraphParos from './GraphParos';

export default function CategoParos() {
    const { notify, areas } = useGeneral();

    return (
        <div className="parosView-body-tittle">
            <div className="parosView-body-tittle-first">
                <div className="parosView-body-tittle-first-left">
                    <Badge
                        badgeContent={notify}
                        color="primary"
                        overlap="circular"
                        className="parosView-body-tittle-first-left-badge"
                    >
                        <h3 className="parosView-body-tittle-text">Paros sin Categorizar </h3>
                    </Badge>
                </div>

                <div className="parosView-body-tittle-first-rigth">
                    <SimpleTabs />
                </div>
            </div>
            <div className="parosView-body-tittle-second">
                <GraphParos />
            </div>
            <div className="parosView-body-table">
                <TablaParos />
            </div>

            <div className="parosView-body-tittle-llamados">
                {areas.map((area, index) => (
                    <div key={area.codigo || index} className={`parosView-body-tittle-llamados-etiquetas${area.codigo}`}>
                        <h1 id={index}>
                            {area.nombre}
                        </h1>
                    </div>
                ))}
                <div className="parosView-body-tittle-llamados-etiquetasS">
                    <h1>Sin Categorizar</h1>
                </div>
            </div>
        </div>
    );
}
